import { DEPARTMENTS, type Department } from './model.ts';

/**
 * Tasks by department, as the Timeline filters its entries (P-23, A-#249 2; Arthur's rulings A-#257 1A and 2A, 28
 * October 2026). On the page only, where the whole list has arrived: My tasks (every task the reader holds and this
 * week's done) and a client's Open tab (up to 200, more than any client holds). The five are the task departments,
 * DEPARTMENTS, the one list: Executive and AP/AR hold no tasks. Seen follows only what is shown (1A): a screen hands
 * useSeen the filtered rows, never the whole list.
 */

export type DepartmentChoice = Department | '';

export const DEPARTMENT_CHOICES: readonly Department[] = DEPARTMENTS;

/** The tasks of one department, in the order given; '' is all of them. */
export function inDepartment<T extends { department: string }>(tasks: readonly T[], department: DepartmentChoice): T[] {
  return department === '' ? [...tasks] : tasks.filter((t) => t.department === department);
}

/** Each group with only its tasks of the department; every group is kept, so its count says 0 rather than vanishing. */
export function groupsInDepartment<G extends { tasks: readonly { department: string }[] }>(groups: readonly G[],
  department: DepartmentChoice): G[] {
  return groups.map((g) => ({ ...g, tasks: inDepartment(g.tasks, department) }));
}
